

export const tableData = {
  tHead: [
    {
      key: 'index',
      dataIndex: 'index',
      title: '序号',
      fixed: 'left',
      width: 50,
      slot: 'index',
    },
    {
      key: 'museumname',
      dataIndex: 'museumname',
      title: '优秀',
      width: 100,
    },
    {
      key: 'project',
      dataIndex: 'project',
      title: '合格',
      width: 100,
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '基本合格',
    },
    {
      key: 'add',
      dataIndex: 'add',
      title: '不合格',
    },
    {
      key: 'personcount',
      dataIndex: 'personcount',
      title: '小记',
    }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
